module.exports = __webpack_public_path__ + "img/stacked_column.612ecf32.svg";